import { Injectable } from 'angular-ts-decorators';

import { CashierModel } from '@account-management/app/scripts/classes/cashier-model';

/**
 * Service that stores the data about cashier for POS
 */
@Injectable('cashierSession')
export class CashierSession {
  /**
   * True when we have an active cashier session
   */
  isActive: boolean = false;
  cashier: CashierModel;

  /**
   * Sets the cashier to the session
   * @param cashier to be set
   */
  set(cashier: CashierModel): void {
    this.isActive = true;
    this.cashier = cashier;
  }

  /**
   * Finish the cashier session
   */
  reset(): void {
    this.isActive = false;
    delete this.cashier;
  }
}
